import { useSiteId } from '@/common/app/site'

import Content from '@/components/view/layouts/page/Content'
import Main, { MainLayoutType } from '@/components/view/layouts/page/Main'
import PageTitle from '@/components/view/molecules/title/PageTitle'

import AppTitleBadge, { AppTitleBadgeType } from '@/components/container/layout/AppTitleBadge'
import MediaGscLinkagePanel from '@/components/container/modules/media/gsc/MediaGscLinkagePanel'

// GSC連携（自社管理サイトの実検索データ分析。既存のOAuth連携・分析ロジックをそのまま引き継ぐ）
const MediaGscLinkagePage = () => {
  const siteId = useSiteId()

  return (
    <Main type={MainLayoutType.SMALL}>
      <PageTitle
        title='GSC連携'
        badgeNode={<AppTitleBadge type={AppTitleBadgeType.MEDIA} />}
        description={
          'Google Search Consoleと連携して、自社サイトの実検索データ（流入キーワード・クリック・表示・掲載順位）を分析します。'
        }
      />
      <Content>
        <MediaGscLinkagePanel siteId={siteId} />
      </Content>
    </Main>
  )
}

export default MediaGscLinkagePage
